import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { BusinessClassificationActions } from "../actions/business-classification.actions";
import { BusinessClassificationState } from "../models/business-classification-state";

const initialState: BusinessClassificationState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(BusinessClassificationActions.loaded, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(BusinessClassificationActions.failed, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function businessClassificationReducer(
	state: BusinessClassificationState | undefined,
	action: Action
) {
	return reducer(state, action);
}
